import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonFlex, CommonGrid, PageTitle } from '../../styledComponents/common';
import ComplaintsList from './ComplaintsList';
import ComplaintsFilterContainer from './Filter/ComplaintsFilterContainer';
import { ButtonIcon, WhiteButtonWithIcon } from 'styledComponents/buttons';
import ButtonTextLoader from 'components/Loaders/ButtonTextLoader';
import excelIcon from '../../assets/img/icons/excel-green.svg';

const Complaints = ({
  getComplaintsList,
  complaintsList,
  isLoading,
  reportLoading,
  sendExportExcelRequest
}) => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState('list');
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [selectedParams, setSelectedParams] = useState({});

  useEffect(() => {
    getComplaintsList();
  }, []);

  const handleChangePage = (page, complaintData) => {
    setCurrentPage(page);
    if (page === 'details' && complaintData) {
      setSelectedComplaint(complaintData);
    }
  };

  const handleExportToExcel = () => {
    sendExportExcelRequest(selectedParams, 'complaints');
  };

  return (
    <div className="content">
      <CommonGrid alignItem="center">
        <PageTitle>{t('complaints')}</PageTitle>
        <CommonFlex gap="12px">
          {localStorage.getItem('user_role') !== 'employee' ? (
            <WhiteButtonWithIcon
              onClick={() => handleExportToExcel()}
              color="#19AC65"
              borderColor="#19AC65"
              hoverBorderColor="#129652"
              padding={reportLoading ? '0 45px' : '0 25px'}
            >
              {reportLoading ? (
                <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
              ) : (
                <>
                  <ButtonIcon src={excelIcon} size="26px" />
                  {t('export_report')}
                </>
              )}
            </WhiteButtonWithIcon>
          ) : null}
        </CommonFlex>
      </CommonGrid>
      <ComplaintsFilterContainer
        setSelectedParams={setSelectedParams}
        selectedParams={selectedParams}
      />
      {currentPage === 'list' ? (
        <>
          <ComplaintsList
            handleChangePage={handleChangePage}
            isLoading={isLoading}
            complaintsList={complaintsList}
            selectedComplaint={selectedComplaint}
            selectComplaint={setSelectedComplaint}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Complaints;
